<template>
    <v-container>
        <v-row>
            <v-col cols="12" >
                <h2 class="mt-5">Researches</h2>
                <v-btn @click="dialog = true" class="gradient-button">Add Research</v-btn>
            </v-col>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="researches"
                    mobile-breakpoint="100"
                    class="elevation-1 datat"
                >
                    <template v-slot:[`item.research`]="{ item }">
                        <v-btn small @click="uploadPDF(item)" color="green" class="ml-2">Upload PDF</v-btn>
                        <v-btn v-if="item.pdf" small @click="viewPDF(item)" color="green" class="ml-2 gradient-button">View PDF</v-btn>
                        <v-btn small @click="editResearch(item)" class="ml-2" color="orange">
                            Add Update
                        </v-btn>
                        <v-btn v-if="item.research_data != ''" small @click="openResearch(item)" class="ml-2" color="blue">
                            View Update
                        </v-btn>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-btn small @click="edit(item)" icon color="orange">
                            <v-icon color="orange">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn small @click="deleteItem(item)" icon color="red">
                            <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog" max-width="700">
                <v-card>
                    <v-card-title>Research Details</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="stock" outlined label="Stock"></v-text-field>
                        <v-text-field v-model="company" outlined label="Company"></v-text-field>
                        <v-text-field v-model="position_id" outlined label="Position ID"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="!editing" :loading="loading" @click="addResearch" class="gradient-button"> Add </v-btn>
                        <v-btn v-else :loading="loading" @click="updateResearch" class="gradient-button"> Update </v-btn>
                        <v-btn color="red" @click="close">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="deleteDialog" max-width="400">
                <v-card>
                    <v-card-title>Alert!</v-card-title>
                    <v-card-text>
                        <h3>Are you sure you want to delete this record?</h3>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="confirmDelete" :loading="loading" class="gradient-button">yes!</v-btn>
                        <v-btn color="red" @click="close">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog1"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">
                <v-card v-if="dialog1">
                    <v-toolbar
                    dark
                    color="primary"
                    >
                    <v-btn
                        icon
                        dark
                        @click="dialog1 = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ item.stock }} | {{ item.company }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                        rounded
                        :loading="loading"
                        color="green"
                        @click="updateData"
                        >
                        Save
                        </v-btn>
                    </v-toolbar-items>
                    </v-toolbar>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <editor
                                ref="toastEditor"
                                :initialValue="research_data"
                                height="600px"
                                initialEditType="wysiwyg"        
                                useCommandShortcut="true"
                                @change="onEditorChange"
                            />
                                        </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog2"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">
                <v-card v-if="dialog2">
                    <v-toolbar
                    dark
                    color="primary"
                    >
                    <v-btn
                        icon
                        dark
                        @click="dialog2 = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ item.stock }} | {{ item.company }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <viewer :initialValue="research_data" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog3"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">
                <v-card v-if="dialog3">
                    <v-toolbar
                    dark
                    color="primary"
                    >
                    <v-btn
                        icon
                        dark
                        @click="close"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ item.stock }} | {{ item.company }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-row>
                        <v-col cols="12">
                            <PdfViewer :pdfUrl="item.pdf" />
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import { supabase } from '../supabase';
import { Viewer } from '@toast-ui/vue-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';
// import PdfViewer from './PdfViewer.vue';
import PdfViewer from './PdfViewer1.vue';
    export default {
        data:() => ( {
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Stock', value: 'stock' },
                { text: 'Company', value: 'company' },
                { text: 'Research', value: 'research' },
                { text: 'Position ID', value: 'position_id' },
                { text: 'Actions', value: 'actions' },
            ],
            researches: [],
            dialog: false,
            dialog1: false,
            dialog2: false,
            dialog3: false,
            deleteDialog: false,
            stock: null,
            company: null,
            research_data: '',
            position_id: null,
            loading: false,
            item: null,
            editing: false
        }),

        methods: {
        async getResearches() {
            const { data, error } = await supabase
                .from('researches')
                .select('*')
                .order('created_at', { ascending: false })
            if (error) {
                console.error('Error fetching positions:', error);
                this.loading = false;
            } else {
                this.researches = []
                this.researches = data;
                this.loading = false;
            }
        },

        async addResearch(){
            const { data, error } = await supabase
                .from('researches')
                .insert({
                    stock: this.stock,
                    company: this.company,
                    research_data: '',
                    position_id: this.position_id
                })
            if (error && !data) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                this.loading = false;
            } else {
                this.$store.dispatch('createAlert',{type: 'success', message: 'Research Created!'})
                this.getResearches()
                this.loading = false;
            }
        },

        viewPDF(item) {
            console.log(item);
            this.item = item
            this.dialog3 = true
        },

        editResearch(item){
            this.dialog1 = true
            this.item = item
            this.research_data = item.research_data
        },

        uploadPDF(item){
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'application/pdf';
            input.onchange = async (e) => {
                const file = e.target.files[0];
                if (!file) return;
                this.loading = true;
                const filePath = `research_${item.id}_${Date.now()}.pdf`;
                const { error: uploadError } = await supabase.storage
                    .from('pdfs')
                    .upload(filePath, file, { upsert: true });
                if (uploadError) {
                    this.$store.dispatch('createAlert', { type: 'error', message: uploadError.message });
                    this.loading = false;
                    return;
                }
                const { data: urlData } = supabase.storage.from('pdfs').getPublicUrl(filePath);
                const pdfUrl = urlData.publicUrl;
                const { error: updateError } = await supabase
                    .from('researches')
                    .update({ pdf: pdfUrl })
                    .eq('id', item.id);
                if (updateError) {
                    this.$store.dispatch('createAlert', { type: 'error', message: updateError.message });
                } else {
                    this.$store.dispatch('createAlert', { type: 'success', message: 'PDF uploaded!' });
                    this.getResearches();
                }
                this.loading = false;
            };
            input.click();
        },

        openResearch(item){
            this.dialog2 = true
            this.item = item
            this.research_data = item.research_data
        },

        async updateResearch() {
            this.loading = true
            const { data, error } = await supabase
                .from('researches')
                .update({ stock: this.stock, company: this.company, position_id: this.position_id })
                .eq('id', this.item.id)
            if (error) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                this.close()
            } else {
                this.$store.dispatch('createAlert',{type: 'success', message: 'Research updated!'})
                this.getResearches()
                console.log(data);
                this.close()
            }
        },

        async updateData() {
            this.loading = true
            const { data, error } = await supabase
                .from('researches')
                .update({ research_data: this.research_data })
                .eq('id', this.item.id)
            if (error) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                this.close()
            } else {
                this.$store.dispatch('createAlert',{type: 'success', message: 'Research updated!'})
                this.getResearches()
                console.log(data);
                this.close()
            }
        },

        edit(item){
            this.stock = item.stock
            this.company = item.company
            this.position_id = item.position_id
            this.item = item
            this.editing = true
            this.dialog = true
            console.log(item);
        },

        deleteItem(item) {
            this.item = item
            this.deleteDialog = true
        },

        async confirmDelete() {
            this.loading = true
            const { data, error } = await supabase
                .from('researches')
                .delete()
                .eq('id', this.item.id)
            if (error) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                this.close()
            } else {
                this.$store.dispatch('createAlert',{type: 'alert', message: 'Research deleted!'})
                this.getResearches()
                console.log(data);
                this.close()
            }
        },

        onEditorChange() {
            const markdown = this.$refs.toastEditor.invoke('getMarkdown');
            this.research_data = markdown;
        },

        close(){
            this.dialog = false
            this.dialog1 = false
            this.dialog2 = false
            this.dialog3 = false
            this.deleteDialog = false
            this.item = null
            this.stock = null
            this.company = null
            this.research_data = ''
            this.loading = false
            this.editing = false
        }
    },
    components: { Viewer, Editor, PdfViewer },
    mounted() {
        if(this.researches.length == 0) {
            this.getResearches()
        }
    }
}
</script>